import React, { Component } from 'react';
import { Modal, Table, Tag } from 'antd/lib';
import moment from 'moment';
import { withApollo } from 'react-apollo';

import getLogsPorId from '../../graphql/querys/logsEmail/getLogsPorId.graphql';
import { errorService } from '../../graphql/utils/utils';

class ModalVisorEmail extends Component {
  state = {
    data: [],
  };

  handleOk = () => {
    this.props.ocultarModalMandarEmail();
  };

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.id !== prevProps.id && this.props.id) {
      // console.log('ENTRE A BUSCAR LOS LOGS ', this.props.id);
      this.props.client
        .query({
          query: getLogsPorId,
          variables: { _id: this.props.id },
          fetchPolicy: 'network-only',
        })
        .then(res => {
          this.setState({
            data: res.data.getLogsPorId,
          });
        })
        .catch(err => {
          console.log('Error en la obtencion del registro de emails enviado');
          console.log(err);
          errorService(err, {
            id: this.props.id,
          });
          Modal.error({
            title: 'Error en la obtencion del registro de emails enviados',
            content:
              'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
          });
        });
    }
  }

  sortFechas = (a, b) => {
    let fechaA = a.fecha;
    let fechaB = b.fecha;

    if (fechaA > fechaB) {
      // console.log("A");
      return 1;
    }
    if (fechaA < fechaB) {
      // console.log("B");
      return -1;
    }

    if (fechaA == fechaB) {
      // console.log("C");
      return 0;
    }
  };

  render() {
    // console.log('DATA:');
    // console.log(this.state.data);
    const columns = [
      {
        title: 'Fecha de Envio',
        dataIndex: 'fecha',
        key: 'fecha',
        defaultSortOrder: 'descend',
        sorter: (a, b) => this.sortFechas(a, b),
        render: fecha => moment(fecha).format('DD/MM/YYYY HH:mm'),
      },
      {
        title: 'Enviado a',
        dataIndex: 'receptor',
        key: 'receptor',
      },
      {
        title: 'Enviado Por',
        dataIndex: 'usuario',
        key: 'usuario',
      },
      {
        title: 'Estado',
        key: 'estado',
        dataIndex: 'error',
        render: error =>
          error ? (
            <Tag color={'#FF0000'} key={error}>
              ERROR
            </Tag>
          ) : (
            <Tag color={'#00FF00'} key={error}>
              ENVIADO
            </Tag>
          ),
      },
    ];

    return (
      <div>
        <Modal
          title="Historial de Emails del Documento"
          visible={this.props.visibleModalLogsEmail}
          onCancel={this.props.ocultarModalLogsEmail}
          onOk={this.handleOk}
          width={1000}
          footer={[]}
        >
          <Table
            rowKey={'_id'}
            columns={columns}
            dataSource={this.state.data}
            title={this.props.titulo}
            pagination={false}
          />
        </Modal>
      </div>
    );
  }
}

export default withApollo(ModalVisorEmail);
